import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PurchaseCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center p-6">
      <div className="text-center space-y-6 max-w-md">
        <div className="w-16 h-16 rounded-full bg-[#262626] flex items-center justify-center mx-auto">
          <XCircle className="w-8 h-8 text-[#a3a3a3]" />
        </div>
        <h1 className="text-2xl font-['Syne'] font-bold text-[#e5e5e5]">
          Purchase Cancelled
        </h1>
        <p className="text-[#a3a3a3]">
          No worries! Your payment was not processed. You can always come back when you're ready.
        </p>
        <p className="text-sm text-[#525252]">
          Remember: Book 1 is always free!
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
          <button
            onClick={() => navigate("/store")}
            className="px-6 py-3 bg-signal-red text-white font-mono uppercase tracking-wider hover:bg-red-700 transition-colors"
          >
            Try Again
          </button>
          <button
            onClick={() => navigate("/")}
            className="px-6 py-3 border border-[#262626] text-[#a3a3a3] font-mono uppercase tracking-wider hover:border-[#e5e5e5] hover:text-[#e5e5e5] transition-colors"
          >
            Return Home
          </button>
        </div>
      </div>
    </div>
  );
}
